var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataintegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4088_168583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 11.2466V23.8326C0.9375 24.2201 1.25163 24.5343 1.63912 24.5343H6.57225C6.01437 25.3256 5.71075 26.3104 5.78487 27.3694C5.93562 29.5251 7.67813 31.2701 9.82738 31.4165C12.372 31.5899 14.4899 29.5706 14.4899 27.055C14.4899 26.116 14.1937 25.2468 13.6915 24.5343H23.7575C24.145 24.5343 24.4591 24.2201 24.4591 23.8326V17.7191C24.4591 17.2569 24.0204 16.9226 23.5741 17.0429C23.214 17.1399 22.8355 17.1917 22.4449 17.1917C19.9391 17.1917 17.9274 15.0703 18.0969 12.52C18.2416 10.3424 20.0111 8.58387 22.1829 8.45562C22.6637 8.42725 23.1286 8.47763 23.5665 8.59463C24.0157 8.71475 24.4592 8.39 24.4592 7.925V1.63912C24.4592 1.25163 24.1451 0.9375 23.7576 0.9375H3.65862C2.15575 0.9375 0.9375 2.15962 0.9375 3.66725V7.50313",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6589 58.9604C35.578 58.9604 33.9175 57.1541 34.1507 55.0191C34.3297 53.3797 35.6524 52.0649 37.2878 51.8968C38.1181 51.8114 38.8966 52.0164 39.5371 52.4212V39.4658H29.9334C29.4357 39.4658 29.1061 39.9656 29.2831 40.4306C29.502 41.0056 29.6032 41.6387 29.557 42.3009C29.4062 44.4567 27.6637 46.2017 25.5145 46.3481C22.9699 46.5216 20.852 44.5022 20.852 41.9866C20.852 41.4366 20.9536 40.9106 21.1386 40.4259C21.3154 39.9631 20.9827 39.4658 20.4871 39.4658H16.7172C16.3297 39.4658 16.0156 39.7799 16.0156 40.1674V60.3328C16.0156 61.8404 17.2339 63.0626 18.7367 63.0626H39.5371V58.4169C38.9931 58.7607 38.3494 58.9604 37.6589 58.9604Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0624 51.3306V39.4659H55.8642C56.4758 38.5731 56.8344 37.4921 56.8346 36.3268C56.8346 33.2621 54.3086 30.7503 51.2538 30.7763C48.2202 30.8022 45.7689 33.2772 45.7689 36.3267C45.7689 37.4921 46.1277 38.5729 46.7393 39.4659H39.5411V52.4213C38.9006 52.0166 38.1221 51.8117 37.2917 51.8969C35.6563 52.0649 34.3338 53.3797 34.1547 55.0192C33.9216 57.1542 35.5819 58.9606 37.6628 58.9606C38.3533 58.9606 38.9969 58.7609 39.5411 58.4172V63.0626H60.3414C61.8442 63.0626 63.0626 61.8404 63.0626 60.3328V55.0719",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5364 16.5706V23.8746C38.8619 23.5211 38.0844 23.3384 37.26 23.3871C35.0883 23.5154 33.3188 25.2739 33.174 27.4515C33.0045 30.0018 35.0163 32.1233 37.522 32.1233C38.2489 32.1233 38.9338 31.9438 39.5363 31.628V39.4659H46.7345C46.1229 38.573 45.7642 37.4921 45.7642 36.3268C45.764 33.262 48.2902 30.7503 51.345 30.7763C54.3787 30.8021 56.8299 33.2773 56.8299 36.3266C56.8299 37.492 56.4713 38.5729 55.8595 39.4659H63.0579V18.5989C63.0579 17.0913 61.8397 15.8691 60.3368 15.8691H40.238C39.8505 15.869 39.5364 16.1831 39.5364 16.5706Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.125 18.4584V14.1331L41.1224 8.13574H54.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9568 10.5223C58.2748 10.5223 59.3433 9.45379 59.3433 8.13577C59.3433 6.81774 58.2748 5.74927 56.9568 5.74927C55.6388 5.74927 54.5703 6.81774 54.5703 8.13577C54.5703 9.45379 55.6388 10.5223 56.9568 10.5223Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8594 19.9584V5.70837",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8631 5.7105C32.1811 5.7105 33.2496 4.64203 33.2496 3.324C33.2496 2.00597 32.1811 0.9375 30.8631 0.9375C29.545 0.9375 28.4766 2.00597 28.4766 3.324C28.4766 4.64203 29.545 5.7105 30.8631 5.7105Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.125 41V36L22 32.875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3162 33.574C21.6342 33.574 22.7027 32.5056 22.7027 31.1875C22.7027 29.8695 21.6342 28.801 20.3162 28.801C18.9982 28.801 17.9297 29.8695 17.9297 31.1875C17.9297 32.5056 18.9982 33.574 20.3162 33.574Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4088_168583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataintegration);
export default __webpack_public_path__ + "static/media/dataintegration.321473936474c27169b8e551b233f816.svg";
export { ForwardRef as ReactComponent };